import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import {
  PledgeRead,
  Parameters,
} from '@app/forms/subscription/definition/interface/Pledge';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };
    let options: AbstractControlOptions = {};

    return this.formBuilder.group(
      {
        realEstateOwnershipType: [
          parameters?.realEstateOwnershipType || 'PLEINE_PROPRIETE_CASH',
        ],
      },
      options,
    );
  }

  get owners() {
    return this.form.get('owners') as FormArray;
  }
  extract() {
    return { ..._.cloneDeep(this.form.value) };
  }
}
